import { Routes } from '@angular/router';

/**
 * Rotas públicas (sem authChildGuard).
 * Login / create-user / redirect-login precisam ficar fora do shell autenticado
 */
export const featuresPublicRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login').then(m => m.LoginComponent)
  },
  {
    path: 'create-user',
    loadComponent: () => import('./create-user/create-user').then(m => m.CreateUserComponent)
  },
  {
    path: 'redirect-login/:ticket',
    loadComponent: () =>
      import('./redirect-login/redirect-login').then(m => m.RedirectLoginComponent)
  }
];
